var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { memo } from 'react';
import { CommunityRepository } from '@amityco/js-sdk';
import { useIntl } from 'react-intl';
import Modal from '../../../core/components/Modal';
import { confirm } from '../../../core/components/Confirm';
import customizableComponent from '../../../core/hocs/customization';
import promisify from '../../../helpers/promisify';
import { CommunityForm } from './styles';
import withSDK from '../../../core/hocs/withSDK';
import { useActionEvents } from '../../../core/providers/ActionProvider';
const CommunityCreationModal = ({ isOpen, onClose, canCreatePublic }) => {
    const { formatMessage } = useIntl();
    const actionEvents = useActionEvents();
    if (!isOpen)
        return null;
    const closeConfirm = () => confirm({
        title: formatMessage({ id: 'CommunityCreationModal.title' }),
        content: formatMessage({ id: 'CommunityCreationModal.content' }),
        cancelText: formatMessage({ id: 'CommunityCreationModal.cancelText' }),
        okText: formatMessage({ id: 'CommunityCreationModal.okText' }),
        onOk: onClose,
    });
    const handleSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { communityId } = yield promisify(CommunityRepository.createCommunity(data));
        (_a = actionEvents.onCommunityCreate) === null || _a === void 0 ? void 0 : _a.call(actionEvents, {
            communityId,
            name: data.displayName,
            isPrivate: !data.isPublic,
        });
        onClose(communityId);
    });
    return (React.createElement(Modal, { isOpen: true, title: formatMessage({ id: 'createCommunity' }), onCancel: closeConfirm, "data-qa-anchor": "community-creation-modal" },
        React.createElement(CommunityForm, { canCreatePublic: canCreatePublic, onCancel: closeConfirm, onSubmit: handleSubmit, "data-qa-anchor": "community-creation" })));
};
export default memo(withSDK(customizableComponent('CommunityCreationModal', CommunityCreationModal)));
//# sourceMappingURL=index.js.map